import {
  Alert,
  AlertSection,
  AlertsCommentary,
  alertRequiresNavAttention,
  schAlertTrigger,
} from '@aloft/toolkit-shared';

import { MutableRefObject } from 'react';

import { processAlertTrigger, retriggerAlertToasts } from '../../redux/features/uiSlice.ts';
import { selectAlerts } from '../../redux/features/selectors/commentarySelectors/selectAlerts.ts';
import { store } from '../../redux/store.ts';
import { AppDispatch } from '../../redux/types.ts';

const ADJUSTMENTS_UPDATE_TRIGGER = schAlertTrigger.enum['update/adjustments'];

export const dispatchAdjustmentsPageAlertTrigger = (
  dispatch: AppDispatch,
  alertsRef: MutableRefObject<Record<AlertSection, Alert[]>>,
  alertsCommentary?: AlertsCommentary,
) => {
  requestAnimationFrame(() => {
    const alertsPerSection = alertsRef.current;
    const dismissedAlerts = selectAlerts(store.getState()).dismissedAlerts ?? [];
    const finalizedExplanations = store.getState().ui.finalizedExplanations;
    const explanationContext = { dismissedAlerts, finalizedExplanations };
    dispatch(
      processAlertTrigger({
        trigger: ADJUSTMENTS_UPDATE_TRIGGER,
        alertsPerSection,
        alertsCommentary,
        explanationContext,
      }),
    );

    const matchingAlertTypes = Object.values(alertsPerSection)
      .flat()
      .filter(
        (alert) =>
          alert.triggers.includes(ADJUSTMENTS_UPDATE_TRIGGER) &&
          alertRequiresNavAttention(alert, alertsCommentary, explanationContext),
      )
      .map((alert) => alert.type);

    if (matchingAlertTypes.length > 0) {
      dispatch(retriggerAlertToasts(matchingAlertTypes));
    }
  });
};
